import { AlertTriangle, Copy, X } from "lucide-react";

interface Props {
  isOpen: boolean;
  officer: any;
  onClose: () => void;
}

export default function OfficerEmailFailedModal({
  isOpen,
  officer,
  onClose,
}: Props) {
  if (!isOpen || !officer) return null;

  const copyCredentials = () => {
    navigator.clipboard.writeText(
      `Username: ${officer.username}
Temporary Password: ${officer.password}
Login URL: ${officer.loginUrl}`,
    );
  };

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-[470px] overflow-hidden rounded-3xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b px-6 py-5">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
              <AlertTriangle className="text-amber-500" size={24} />
            </div>

            <h2 className="text-xl font-bold">
              Officer Created — Action Required
            </h2>
          </div>

          <button onClick={onClose}>
            <X />
          </button>
        </div>

        <div className="p-6">
          <div className="rounded-xl border border-amber-300 bg-amber-50 p-4">
            <p className="text-slate-700 leading-7">
              The account for{" "}
              <span className="font-semibold">
                {officer.firstName} {officer.lastName}
              </span>{" "}
              was created, but the welcome email could not be delivered to{" "}
              <span className="font-semibold">{officer.email}</span>.
            </p>

            <p className="mt-2 text-sm text-slate-600">
              Share these credentials with the user directly.
            </p>
          </div>

          <div className="mt-5 rounded-xl border border-slate-200 bg-slate-50 p-4">
            <div className="mb-4 flex items-center justify-between">
              <span className="font-semibold text-slate-700">
                LOGIN CREDENTIALS
              </span>

              <button
                onClick={copyCredentials}
                className="text-xs font-medium text-blue-600"
              >
                CLICK TO COPY
              </button>
            </div>

            <div className="space-y-3 text-sm">
              <div className="flex">
                <span className="w-36 text-slate-500">Username</span>
                <span className="font-medium">{officer.username}</span>
              </div>

              <div className="flex">
                <span className="w-36 text-slate-500">Temp Password</span>
                <span className="font-medium">{officer.password}</span>
              </div>

              <div className="flex">
                <span className="w-36 text-slate-500">Login URL</span>

                <a
                  href={officer.loginUrl}
                  className="text-blue-600 underline"
                  target="_blank"
                  rel="noreferrer"
                >
                  {officer.loginUrl}
                </a>
              </div>
            </div>
          </div>

          <button
            onClick={copyCredentials}
            className="mt-5 flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-slate-300 font-semibold hover:bg-slate-50"
          >
            <Copy size={18} />
            Copy Credentials
          </button>

          <p className="mt-5 text-center text-xs text-slate-500">
            Credentials shown once. User must set a new password on first login.
          </p>
        </div>
      </div>
    </div>
  );
}
